import React from 'react';
import styled from 'styled-components';
import { Icon } from 'lmc-ui-library';
import { Link } from 'react-router-dom';
import { dashboard } from 'routes/routePaths';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 26px 0;
  margin-bottom: 44px;
  border-bottom: 1px solid #c0c2c6;
  width: 100%;
`;

const BackWrapper = styled.div`
  margin-right: 24px;
`;
const FirmDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const FirmName = styled.span`
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  color: #2d3540;
`;

const Subheading = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #2d3540;
  margin-bottom: 4px;

  span {
    margin-right: 7px;
  }
`;

const Header: React.FC<any> = () => {
  return (
    <Wrapper>
      <BackWrapper>
        <Link to={dashboard}>
          <Icon type="iconLeft" color="#6C7279" />
        </Link>
      </BackWrapper>
      <FirmDetailsWrapper>
        <Subheading>Firms</Subheading>
        <FirmName>All firms</FirmName>
      </FirmDetailsWrapper>
    </Wrapper>
  );
};

export default Header;
